import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;
Wrapper.displayName = 'Wrapper';

export const LabelWrapper = styled.div`
  display: flex;
`;
LabelWrapper.displayName = 'LabelWrapper';

export const Option = styled.div`
`;
Option.displayName = 'Option';

export const dropdownStyle = (theme) => ({
  control: () => ({
    boxShadow: theme.shadows.agentSelectorInScheduler,
    height: '35px',
    width: 'auto',
    borderRadius: '1px',
    backgroundColor: theme.backgrounds.dropdown1,
    border: 'solid 1px ' + theme.textfield.background,
    borderBottomWidth: '0px',
    borderRightWidth: '0px',
    color: theme.textfield.text,
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '13px',
    color: theme.textfield.text,
    position: 'relative',
    fontWeight: 400
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    right: '4px',
    color: '#505965',
    width: '30px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.dropdown1OptionsHover : theme.backgrounds.dropdown1Options,
    fontSize: '14px',
    textAlign: 'left',
    color: theme.textfield.text,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    fontWeight: state.isSelected ? 600 : 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: '2px 2px 30px 0' + theme.shadows.actionDropDown,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '110px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.textfield.text, width: 'fit-content', height: '22px', fontSize: '14px', fontWeight: 400, top: '11px', position: 'relative', maxWidth: 'calc(100% - 24px)'
    };
  }
});
